import { plainToClass } from "class-transformer";
import { IFilter, InitializeFilterDropdown } from "../../../shared/scripts/dropdown-functions";
import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../shared/scripts/table-column-visibility";
import { DoArraysOverlap } from "../../../shared/scripts/array-functions";
import { ListItem, IControllerFilter } from "./list-management.objects";
import { ListController } from "./list-management.controllers";
import _ from 'lodash';

import { PickListItem, PickListItemSorted, PickListItemString } from "./list-management.objects";

export class FilterTab {
    id: string;
    displayName: string;
    columnViewName: string;
    filters: Filter[]

    constructor(id: string, displayName: string, columnViewName: string, filters: Filter[]) {
        this.id = id;
        this.displayName = displayName;
        this.columnViewName = columnViewName;
        this.filters = filters;
    }

    getSelectedValues(): any[] {
        let selectedValues = [];
        for (let i = 0; i < this.filters.length; i++) {
            let selected = this.filters[i].getSelected();
            selectedValues.push(selected);
        }
        return selectedValues;
    }
    setSelectedValues(selectedArr: any[]) : void {
        for (let i = 0; i < selectedArr.length; i++) {
            let filter = this.filters[i];
            let selected = selectedArr[i];
            filter.setSelected(selected);
        }
    }
}

export class Filter {
    id: string;
    displayName: string;
    type: string;
    propertyName: string;
    pickListName: string;
    nestedPropertyArr: string[];
    additionalPickListArr: string[];

    // calculated
    isSearch: boolean = false;

    constructor(id: string, displayName: string, type: string, propertyName: string, pickListName: string = "", nestedPropertyNames: string[] = [], additionalPickLists: string[] = []) {
        this.id = id;
        this.displayName = displayName;
        this.type = type;
        this.propertyName = propertyName;
        this.pickListName = pickListName;
        this.nestedPropertyArr = nestedPropertyNames;
        this.additionalPickListArr = additionalPickLists;

        this.isSearch = false;
        if (this.type.startsWith("search-")) {
            this.isSearch = true;
            this.type = type.replace("search-", "");
        }
    }

    generateFilterHtml(): string {
        if (this.type == "multi-select" || this.type == "multi-select-pl-single" || this.type == "multi-select-pl-multi" || this.type == "multi-select-pl-nested-single" || this.type == "yes-no" || this.type == "multi-select-list-array" || this.type == "multi-select-nested-combined" || this.type == "yes-no-not-null") {
            let liveSearch = "";
            if (this.isSearch) {
                liveSearch = `data-live-search="true"`
            }

            let html = `
                <div id="${this.id}-select" class="col-12 col-md-3 mb-2">
                    <div id="${this.id}-block" class="filter-label d-inline-block label-only">${this.displayName}</div>
                    <select id="${this.id}-dropdown" class="selectpicker dropdown" title="None Selected" data-actions-box="true" data-width="100%" data-container="body" data-size="10"  ${liveSearch} multiple>
                    </select>
                </div>`

            return html;
        }
        else if (this.type == "date-before" || this.type == "date-after") {
            let html = `
                <div id="${this.id}-select" class="col-12 col-md-3 mb-2">
                    <div id="${this.id}-block" class="filter-label d-inline-block label-only">${this.displayName}</div>
                    <input class="font-size12" id="${this.id}-input" type="date"/>
                </div>
            `
            return html;
        }
        else if (this.type == "date-before-after") {
            let html = `
                <div id="${this.id}-select" class="col-12 col-md-3 mb-2">
                    <div id="${this.id}-block" class="filter-label d-inline-block label-only">${this.displayName}</div>
                    <div class='row justify-content-between date-before-after-filter-item'>
                        <div class='col-6'>
                            <div class="filter-label d-inline-block label-only">After</div>
                            <input class="font-size12" id="${this.id}-input-after" type="date"/>
                        </div>
                        <div class='col-6'>
                            <div class="filter-label d-inline-block label-only">Before</div>
                            <input class="font-size12" id="${this.id}-input-before" type="date"/>
                        </div> 
                    </div>     
                </div>
            `
            return html;
        }
        else {
            return "";
        }

    }

    initializeDropdown(items: any[], controller: IControllerFilter, pickList: PickListItem[] = []): void {
        if (this.type == "multi-select") {
            let options: any[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptions = _.uniq(options);
            uniqueOptions = uniqueOptions.map(option => {
                if (!option) {
                    return "--None--";
                }
                return option;
            });
            uniqueOptions.sort((x1: string, x2: string) => {
                if (x1.startsWith("-") && !x2.startsWith("-")) {
                    return 1;
                }
                else if (x2.startsWith("-") && !x1.startsWith("-")) {
                    return -1;
                }
                else {
                    return x1.localeCompare(x2);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, uniqueOptions, controller);
        }
        else if (this.type == "multi-select-pl-single") {
            let optionIds: number[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptionIds = _.uniq(optionIds);
            let options: any[] = uniqueOptionIds.map(optionId => {
                if (!optionId) {
                    optionId = 0;
                }
                let foundOptionList = pickList.find(item => item.Id == optionId);
                let foundOption = "--None--"
                if (foundOptionList) {
                    foundOption = foundOptionList.Value;
                }
                return [optionId.toString(), foundOption];
            });
            options.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, null, controller, options);
        }
        else if (this.type == "multi-select-pl-multi") {
            let optionIdStrings: string[] = items.map(item => _.get(item, this.propertyName));
            let uniqueOptionIdStrings = _.uniq(optionIdStrings);
            let uniqueOptionNames: string[] = [];
            let options: any[] = [];
            for (let i = 0; i < uniqueOptionIdStrings.length; i++) {
                let optionString: string = uniqueOptionIdStrings[i];
                if (!optionString) {
                    optionString = "0"
                }

                let optionIdArr: string[] = optionString.split("|");
                for (let j = 0; j < optionIdArr.length; j++) {
                    let optionId = optionIdArr[j];
                    let foundOptionList = pickList.find(item => item.Id.toString() == optionId);
                    let foundOption = "--None--"
                    if (foundOptionList) {
                        foundOption = foundOptionList.Value;
                    }
                    if (!uniqueOptionNames.includes(foundOption)) {
                        options.push([optionId, foundOption]);
                        uniqueOptionNames.push(foundOption);
                    }
                }
            }
            options.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, null, controller, options);
        }
        else if (this.type == "date-before" || this.type == "date-after") {
            $(`#${this.id}-input`).on('change', () => controller.triggerFilter())
        }
        else if (this.type == "date-before-after") {
            $(`#${this.id}-input-after`).on('change', () => controller.triggerFilter());
            $(`#${this.id}-input-before`).on('change', () => controller.triggerFilter());
        }
        else if (this.type == "multi-select-pl-nested-single") {
            let itemArr = items.map(item => _.get(item, this.propertyName));
            let optionIdArr = [];
            for (let i = 0; i < itemArr.length; i++) {
                let currentArr = itemArr[i];
                let nestedOptions = currentArr.map(nestedItem => _.get(nestedItem, this.nestedPropertyArr[0]));
                if (nestedOptions.length > 0) {
                    optionIdArr.push(...nestedOptions);
                }
                else {
                    optionIdArr.push(0)
                }
            }
            let uniqueOptionIds = _.uniq(optionIdArr);
            let options = [];
            for (let i = 0; i < uniqueOptionIds.length; i++) {
                let optionId = uniqueOptionIds[i];
                if (!optionId) {
                    optionId = 0;
                }
                let foundOptionList = pickList.find(item => item.Id.toString() == optionId.toString())
                let foundOption = "--None--";
                if (foundOptionList) {
                    foundOption = foundOptionList.Value;
                }
                options.push([optionId, foundOption])
            }
            options.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, null, controller, options);
        }
        else if (this.type == "yes-no" || this.type == "yes-no-not-null") {
            let options = [["1", "Yes"], ["0", "No"]]
            InitializeFilterDropdown(`#${this.id}-dropdown`, null, controller, options);
        }
        else if (this.type == "multi-select-list-array") {
            let optionArr: string[][] = items.map(item => _.get(item, this.propertyName));
            let options: string[] = [];
            optionArr.forEach(optionCollection => {
                if (optionCollection.length > 0) {
                    options.push(...optionCollection)
                }
                else {
                    options.push("")
                }
            });
            let uniqueOptions = _.uniq(options);
            uniqueOptions = uniqueOptions.map(option => {
                if (!option) {
                    return "--None--";
                }
                return option;
            });
            uniqueOptions.sort((x1: string, x2: string) => {
                if (x1.startsWith("-") && !x2.startsWith("-")) {
                    return 1;
                }
                else if (x2.startsWith("-") && !x1.startsWith("-")) {
                    return -1;
                }
                else {
                    return x1.localeCompare(x2);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, uniqueOptions, controller);
        }      
        else if (this.type == "multi-select-nested-combined") {
            let itemArr = items.map(item => _.get(item, this.propertyName));
            let optionIdArr: number[][] = [];
            for (let i = 0; i < itemArr.length; i++) {
                let currentArr = itemArr[i];
                let nestedOptions = currentArr.map(nestedItem => _.get(nestedItem, this.nestedPropertyArr[0]));
                let additionalNestedOptions = currentArr.map(nestedItem => _.get(nestedItem, this.nestedPropertyArr[1]));
                let combinedOptionsIds: number[][] = [];
                for (let i = 0; i < nestedOptions.length; i++) {
                    let primaryId = nestedOptions[i];
                    let secondaryId = additionalNestedOptions[i];

                    let existingOption = optionIdArr.find(option => option[0] == primaryId);
                    let additionalExistingOption = combinedOptionsIds.find(option => option[0] == primaryId);
                    if (!existingOption && !additionalExistingOption) {
                        combinedOptionsIds.push([primaryId, secondaryId]);
                    }
                }
                if (combinedOptionsIds.length > 0) {
                    optionIdArr.push(...combinedOptionsIds);
                }
                else {
                    let existingOption = optionIdArr.find(option => option[0] == 0);
                    if (!existingOption) {
                        optionIdArr.push([0, 0]);
                    }
                }
            }
            let options = [];
            for (let i = 0; i < optionIdArr.length; i++) {
                let optionId: number[] = optionIdArr[i];
                let foundOptionList = pickList.find(item => item.Id == optionId[0])              
                let foundOption = "--None--";
                if (foundOptionList) {
                    let additionalPickList: PickListItem[] = controller.pickLists.find(picklist => picklist.Id == this.additionalPickListArr[0])?.Json;
                    if (additionalPickList) {
                        let additionalInfo = additionalPickList.find(item => item.Id == optionId[1]);
                        if (additionalInfo) {
                            foundOption = `${additionalInfo.Value} - ${foundOptionList.Value}`;
                        }
                    }
                }
                options.push([optionId[0].toString(), foundOption])
            }
            options.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
            InitializeFilterDropdown(`#${this.id}-dropdown`, null, controller, options);
        }
        
    }

    filterItems(items: ListItem[]): ListItem[] {
        let filteredItems = items;

        if (this.type == "multi-select") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            selectedItems = selectedItems.map(item => {
                if (item == "--None--") {
                    return "";
                }
                else {
                    return item;
                }
            })
            filteredItems = filteredItems.filter(item => selectedItems.includes(_.get(item, this.propertyName)));
        }
        else if (this.type == "multi-select-pl-single") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            let parsedValues: number[] = [];
            selectedItems.forEach(value => parsedValues.push(parseInt(value)));
            filteredItems = filteredItems.filter(item => {
                let itemVal = _.get(item, this.propertyName);
                if (!itemVal) {
                    itemVal = 0;
                }
                return parsedValues.includes(itemVal);
            });
        }
        else if (this.type == "multi-select-pl-multi") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            filteredItems = filteredItems.filter(item => {
                let valueArr: string = _.get(item, this.propertyName);
                if (!valueArr) {
                    valueArr = "0"
                }
                return DoArraysOverlap(selectedItems, valueArr.split("|"));
            })
        }
        else if (this.type == "multi-select-pl-nested-single" || this.type == "multi-select-nested-combined") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            let parsedValues: number[] = [];
            selectedItems.forEach(value => parsedValues.push(parseInt(value)));

            filteredItems = filteredItems.filter(item => {
                let itemArr = _.get(item, this.propertyName);
                let optionIdArr = [];
                let nestedOptionArr = itemArr.map(nestedItem => _.get(nestedItem, this.nestedPropertyArr[0]));
                if (nestedOptionArr.length > 0) {
                    optionIdArr.push(...nestedOptionArr);
                }
                else {
                    optionIdArr.push(0);
                }
                return DoArraysOverlap(parsedValues, optionIdArr);
            })
        }
        else if (this.type == "date-before") {
            let dateValue = <string>$(`#${this.id}-input`).val();
            if (dateValue) {
                let selectedDate = new Date(dateValue);
                filteredItems = filteredItems.filter(item => {
                    let itemDate = new Date(_.get(item, this.propertyName));
                    return (selectedDate.getTime() >= itemDate.getTime());
                })
            }
        }
        else if (this.type == "date-after") {
            let dateValue = <string>$(`#${this.id}-input`).val();
            if (dateValue) {
                let selectedDate = new Date(dateValue);
                filteredItems = filteredItems.filter(item => {
                    let itemDate = new Date(_.get(item, this.propertyName));
                    return (selectedDate.getTime() <= itemDate.getTime());
                })
            }
        }
        else if (this.type == "date-before-after") {
            let afterDateValue = <string>$(`#${this.id}-input-after`).val();
            if (afterDateValue) {
                let selectedDate = new Date(afterDateValue);
                filteredItems = filteredItems.filter(item => {
                    let itemDate = new Date(_.get(item, this.propertyName));
                    return (selectedDate.getTime() <= itemDate.getTime());
                });
            }

            let beforeDateValue = <string>$(`#${this.id}-input-before`).val();
            if (beforeDateValue) {
                let selectedDate = new Date(beforeDateValue);
                filteredItems = filteredItems.filter(item => {
                    let itemDate = new Date(_.get(item, this.propertyName));
                    return (selectedDate.getTime() >= itemDate.getTime());
                })
            }
        }
        else if (this.type == "yes-no") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            let parsedValues: boolean[] = [];
            selectedItems.forEach(item => {
                if (item == "1") {
                    parsedValues.push(true);
                }
                else if (item == "0") {
                    parsedValues.push(false);
                }
            });
            filteredItems = filteredItems.filter(item => {
                return DoArraysOverlap(parsedValues, [_.get(item, this.propertyName)])
            })
        }
        else if (this.type == "yes-no-not-null") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            let parsedValues: boolean[] = [];
            selectedItems.forEach(item => {
                if (item == "1") {
                    parsedValues.push(true);
                }
                else if (item == "0") {
                    parsedValues.push(false);
                }
            });
            filteredItems = filteredItems.filter(item => {
                let isTruthy = false;
                if (_.get(item, this.propertyName)) {
                    isTruthy = true;
                }
                return DoArraysOverlap(parsedValues, [isTruthy])
            })
        }
        else if (this.type == "multi-select-list-array") {
            let selectedItems = <string[]>$(`#${this.id}-dropdown`).val();
            selectedItems = selectedItems.map(item => {
                if (item == "--None--") {
                    return "";
                }
                else {
                    return item;
                }
            })
            filteredItems = filteredItems.filter(item => {
                if (selectedItems.includes("")) {
                    let doArraysOverlap: boolean = DoArraysOverlap(selectedItems, _.get(item, this.propertyName));
                    let isEmpty: boolean = _.get(item, this.propertyName).length == 0;
                    return (doArraysOverlap || isEmpty);
                }
                return DoArraysOverlap(selectedItems, _.get(item, this.propertyName));
            }); 
        }

        return filteredItems;
    }

    getSelected(): string | string[] | number {
        let specialTypes: string[] = ["deliverable-subcategory", "deliverable-furthest-stage", "am-core-project-filter", "ms-core-project-filter"];

        if (!specialTypes.includes(this.type)) {
            let selectedValues = $(`#${this.id}-dropdown`).val();
            if (this.type == "multi-select" || this.type == "multi-select-pl-single" || this.type == "multi-select-pl-multi" || this.type == "multi-select-pl-nested-single" || this.type == "yes-no" || this.type == "multi-select-list-array" || this.type == "multi-select-nested-combined" || this.type == "trl-tag" || this.type == "deliverable-category" || this.type == "deliverable-responsible-person" || this.type == "yes-no-not-null") {
                let totalOptionsCount = $(`#${this.id}-dropdown`).find("option").length;
                let selectedValuesCount = (<string[]>selectedValues).length;
                if (totalOptionsCount == selectedValuesCount) {
                    selectedValues = ["All"]
                }
            }
            return selectedValues;
        }
        else if (this.type == "deliverable-subcategory" || this.type == "deliverable-furthest-stage" || this.type == "am-core-project-filter" || this.type == "ms-core-project-filter") {
            let returnOptions: string[] = []
            let selectedOptions = $(`#${this.id}-dropdown`).find("option:selected").toArray();
            selectedOptions.forEach(option => {
                let optGroup = $(option).closest("optgroup").first();
                if (optGroup) {
                    let groupId = $(optGroup).data("groupId");
                    let val = $(option).prop("value");
                    returnOptions.push(`${groupId}-${val}`);
                }
            });
            return returnOptions;
        }
    }

    setSelected(selectedValues: string | string[] | number): void {
        let specialTypes: string[] = ["deliverable-subcategory", "deliverable-furthest-stage", "trl-tag", "deliverable-category", "deliverable-responsible-person", "am-core-project-filter", "ms-core-project-filter"];

        if (this.type == "multi-select" || this.type == "multi-select-pl-single" || this.type == "multi-select-pl-multi" || this.type == "multi-select-pl-nested-single" || this.type == "yes-no" || this.type == "multi-select-list-array" || this.type == "multi-select-nested-combined" || this.type == "yes-no-not-null") {
            let selectedValuesCount = (<string[]>selectedValues).length;
            if (selectedValuesCount == 1) {
                if (selectedValues[0] == "All") {
                    $(`#${this.id}-dropdown`).selectpicker("selectAll").trigger("change");
                }
                else {
                    $(`#${this.id}-dropdown`).val(selectedValues);
                    $(`#${this.id}-dropdown`).selectpicker("refresh").trigger("change");
                }
            }
            else {
                $(`#${this.id}-dropdown`).val(selectedValues);
                $(`#${this.id}-dropdown`).selectpicker("refresh").trigger("change");
            }
        }
        else if (!specialTypes.includes(this.type)) {
            $(`#${this.id}-dropdown`).val(selectedValues);
        }
        else if (this.type == "deliverable-subcategory" || this.type == "deliverable-furthest-stage" || this.type == "am-core-project-filter" || this.type== "ms-core-project-filter") {
            $(`#${this.id}-dropdown`).selectpicker("deselectAll");
            let selectedOptions = <string[]>selectedValues;
            selectedOptions.forEach(selectVal => {
                let optionArr = selectVal.split("-");
                let optionVal = optionArr.pop();
                let groupId = optionArr.join("-");
                let targetOption = $(`#${this.id}-dropdown`).find(`optgroup[data-group-id="${groupId}"]`).find(`option[value="${optionVal}"]`);
                if (targetOption) {
                    targetOption.prop('selected', true);
                }
            });
            $(`#${this.id}-dropdown`).selectpicker("refresh").trigger("change");
        }
        else if (this.type == "trl-tag" || this.type == "deliverable-category" || this.type == "deliverable-responsible-person") {
            let selectedValuesCount = (<string[]>selectedValues).length;
            if (selectedValuesCount == 1) {
                if (selectedValues[0] == "All") {
                    $(`#${this.id}-dropdown`).selectpicker("selectAll").trigger("change");
                }
                else {
                    $(`#${this.id}-dropdown`).val(selectedValues);
                    $(`#${this.id}-dropdown`).selectpicker("refresh").trigger("change");
                }
            }
            else {
                $(`#${this.id}-dropdown`).val(selectedValues);
                $(`#${this.id}-dropdown`).selectpicker("refresh").trigger("change");
            }
        }
    }

    resetFilter() {
        if (this.type == "multi-select" || this.type == "multi-select-pl-single" || this.type == "multi-select-pl-multi" || this.type == "multi-select-pl-nested-single" || this.type == "yes-no" || this.type == "multi-select-list-array" || this.type == "multi-select-nested-combined" || this.type == "yes-no-not-null") {
            $(`#${this.id}-dropdown`).selectpicker("selectAll");
        }
        else if (this.type == "date-before" || this.type == "date-after") {
            $(`#${this.id}-input`).val("");
        }
        else if (this.type == "date-before-after") {
            $(`#${this.id}-input-after`).val("");
            $(`#${this.id}-input-before`).val("");
        }
    }
}

export class DropdownGroup {
    groupDisplayLabel: string;
    groupId: string;
    options: PickListItem[];
    optionsSorted: PickListItemSorted[];
    optionsStr: PickListItemString[];

    constructor(groupDisplayLabel: string, groupId: string, options: PickListItem[] = null, optionsSorted: PickListItemSorted[] = null, optionsStr: PickListItemString[] = null) {
        this.groupDisplayLabel = groupDisplayLabel;
        this.groupId = groupId;
        this.options = options;
        this.optionsSorted = optionsSorted;
        this.optionsStr = optionsStr;
    }

    createOptGroupHtml(selectAll: boolean = true): string {
        let optionHtml = "";
        let isSelected: string = "";
        if (selectAll) isSelected = "selected"
        if (this.options != null) {
            // Sort Alphabetically
            this.options.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
            this.options.forEach(option => {
                optionHtml += `<option value="${option.Id}" ${isSelected}>${option.Value}</option>`;
            });
        }
        else if (this.optionsSorted != null) {
            // Sort by SortOrder
            this.optionsSorted.sort((x1, x2) => x1.SortOrder - x2.SortOrder);
            this.optionsSorted.forEach(option => {
                optionHtml += `<option value="${option.Id}" ${isSelected}>${option.Value}</option>`;
            });
        }
        else if (this.optionsStr != null) {
            // Sort Alphabetically
            this.optionsStr.sort((x1, x2) => x1.Value.localeCompare(x2.Value));
            this.optionsStr.forEach(option => {
                optionHtml += `<option value="${option.Id}" ${isSelected}>${option.Value}</option>`;
            })
        }

        let content = `
            <optgroup label="${this.groupDisplayLabel}" data-group-id="${this.groupId}">
                ${optionHtml}
            </optgroup>
        `

        return content;
    }
}

   